class PyracrystalTestimonials extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-testimonial-track]');
    this.pages = [...this.querySelectorAll('[data-testimonial-page]')];
    this.dots = [...this.querySelectorAll('[data-testimonial-dot]')];
    this.previousButton = this.querySelector('[data-testimonial-previous]');
    this.nextButton = this.querySelector('[data-testimonial-next]');
    this.currentPage = 0;

    this.previousButton?.addEventListener('click', () => this.showPage(this.currentPage - 1));
    this.nextButton?.addEventListener('click', () => this.showPage(this.currentPage + 1));
    this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.showPage(index)));

    this.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') this.showPage(this.currentPage - 1);
      if (event.key === 'ArrowRight') this.showPage(this.currentPage + 1);
    });

    this.showPage(0);
  }

  showPage(index) {
    if (!this.pages.length) return;

    this.currentPage = (index + this.pages.length) % this.pages.length;
    this.track.style.transform = `translateX(-${this.currentPage * 100}%)`;

    this.pages.forEach((page, pageIndex) => {
      page.setAttribute('aria-hidden', pageIndex === this.currentPage ? 'false' : 'true');
    });

    this.dots.forEach((dot, dotIndex) => {
      dot.setAttribute('aria-current', dotIndex === this.currentPage ? 'true' : 'false');
    });
  }
}

if (!customElements.get('pyracrystal-testimonials')) {
  customElements.define('pyracrystal-testimonials', PyracrystalTestimonials);
}
